module.exports = __webpack_public_path__ + "static/media/IQ.cfbfbc06.png";